import React from 'react'

function CallToActionFive() {
    return (
        <div>
            {/* start call to action area */}
            <div className="rts-callto-acation-area rts-callto-acation-area5">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="cta-two-wrapper">
                                <div className="title-area">
                                    <h3 className="title">
                                        Need Any Marketing Solutions? Contact With Us
                                    </h3>
                                </div>
                                <a className="rts-btn btn-secondary-3" href="contactus.html">
                                    Lets Work Together
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* end call to action area */}
        </div>
    )
}

export default CallToActionFive